module.exports = __webpack_public_path__ + "static/img/null.6cad91ee.png";